import React from "react";
import { useParams } from "react-router-dom";
import Events from "./Events";
import { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";

const Category = () => {

	const [data, setData] = useState([]);
	const { category } = useParams();

	const fetchData = () => {
		return fetch(process.env.REACT_APP_BACKEND_URL + "/events")
			.then((res) => res.json())
			.then((d) => setData(d));
	};

	// Fetches the data from the server 
	useEffect(() => {
		fetchData();
	}, []);

	function returnMatchingCategory(data) {
		return data.filter((data) =>
			data.type.toLowerCase() === category.toLowerCase()
		);
	}

	return (
		<div style={{
			display: "flex",
			justifyContent: "centre",
			alignItems: "centre",
			height: "100vh",
		}}>
			<Box display="inline-block">
				<Typography fontWeight="800" variant="h4" sx={{ m: 2 }}>Events with {category} tag: </Typography>
				<Events eventsData={returnMatchingCategory(data)} />
			</Box>
		</div>
	);
};

export default Category;